import { CalendarDays, CircleDot, MapPin, PlusCircle, Search } from "lucide-react";
import { NavLink } from "react-router-dom";

export const BottomNav = ({ lastRoute, onAssistant, todayCount = 0 }) => {
  const items = [
    { to: "/oggi", label: "Oggi", Icon: CircleDot },
    { to: "/agenda", label: "Agenda", Icon: CalendarDays },
    { to: "/locali", label: "Locali", Icon: MapPin },
    { to: lastRoute, label: lastRoute === "/fissa" ? "Fissa" : "Cerca", Icon: lastRoute === "/fissa" ? PlusCircle : Search },
  ];
  const navItem = ({ to, label, Icon }) => (
    <NavLink key={to} to={to} data-testid={`nav-${label.toLowerCase()}`} className={({ isActive }) => `nav-item${isActive ? " active" : ""}`}>
      <Icon size={24} strokeWidth={1.65} aria-hidden="true" /><span>{label}</span>
      {label === "Oggi" && todayCount > 0 && <b className="nav-task-badge" data-testid="nav-oggi-count">{todayCount > 99 ? "99+" : todayCount}</b>}
    </NavLink>
  );
  return (
    <nav className="bottom-nav" aria-label="Navigazione principale" data-testid="bottom-navigation">
      {items.slice(0, 2).map(navItem)}
      <button type="button" className="orb-button" aria-label="Apri Luchador" title="Luchador" onClick={onAssistant} data-testid="assistant-open-button" />
      {items.slice(2).map(navItem)}
    </nav>
  );
};